module.exports = __webpack_public_path__ + "img/電気回路_6_4.cd30135a.png";